import React from "react";

const FieldPlaceHolder = (props) => {
  return (
    <div className="pt-5 pr-8 row d-flex flex-column">
      <label>Place Holder</label>
      <input
        type="text"
        maxLength="50"
        placeholder="Place Holder"
        value={props.value}
        onChange={props.changeHandler}
      />
    </div>
  );
};

export default FieldPlaceHolder;
